import { render, staticRenderFns } from "./concepts-modal.vue?vue&type=template&id=5d6c2479&scoped=true&"
import script from "./concepts-modal.ts?vue&type=script&lang=ts&"
export * from "./concepts-modal.ts?vue&type=script&lang=ts&"
import style0 from "./concepts-modal.scss?vue&type=style&index=0&id=5d6c2479&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6c2479",
  null
  
)

export default component.exports